import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Paper,
  TextField,
  Button,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  withStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormHelperText,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Box,
  Tabs,
  Tab,
} from '@material-ui/core';
import '@fortawesome/fontawesome-free/css/all.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'; // Import error icon
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'; // Import success icon
import CheckCircleIcon from '@material-ui/icons/CheckCircle'; // Import success icon
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import NumberFormat from 'react-number-format';
import Autocomplete from '@material-ui/lab/Autocomplete';
import crypto from 'crypto'; // Módulo crypto de Node.js (o su polyfill/equivalente)
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import {
  hideGlobalLoading,
  fetchGetServiciosRequest,
  showGlobalLoading,
  fetchSetErrorDialogGlobal,
  fetchSetSuccessDialogGlobal,
  fetchGetEjecutivosRequest,
  fetchGetPuertosRequest,
  fetchGetComunasDestinoRequest,
  fetchGetTiposCargasRequest,
  fetchGetTiposContenedoresRequest,
  fetchGetTiposIncotermsRequest,
  fetchSetCotizacion,
  fetchSetCotizacionErrors,
  fetchSetNumeroWhatsapp,
  fetchGetClienteById,
  fetchCotizacion20Save,
  fetchCotizacion20Accept,
  fetchGetServiciosValoresRequest,
  fetchSendEmailCotizacion
} from './actions';

import envConfig from '../../envConfig';
import { id } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
  loadingOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#dc3545',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    transition: 'opacity 0.3s ease-in-out',
  },
  loadingLogo: {
    width: '200px',
    height: 'auto',
    animation: '$pulse 2s cubic-bezier(0.4, 0, 0.2, 1) infinite',
    filter: 'drop-shadow(0 0 15px rgba(255, 255, 255, 0.5))',
    transform: 'scale(1)',
    willChange: 'opacity, transform, filter',
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.8)',
      filter: 'brightness(0.5) drop-shadow(0 0 5px rgba(255, 255, 255, 0))',
    },
    '50%': {
      opacity: 1,
      transform: 'scale(1.2)',
      filter: 'brightness(1.5) drop-shadow(0 0 40px rgba(255, 255, 255, 1))',
    },
    '100%': {
      opacity: 0,
      transform: 'scale(0.8)',
      filter: 'brightness(0.5) drop-shadow(0 0 5px rgba(255, 255, 255, 0))',
    },
  },
  noPaddingTB: {
    paddingTop: '0px!important',
    paddingBottom: '0px!important',
    marginTop: '0px!important',
    marginBottom: '0px!important'
  },
  infoLabel: {
    cursor: 'pointer'
  },
  selectLabel: {
    marginBottom: '5px !important',
  },
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'row',
    margin: 0,
    padding: 0,
    background: '#ffffff',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: 'Montserrat, sans-serif !important'
  },
  logoContainer: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    zIndex: 1
  },
  logoImage: {
    height: '100px',
    width: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
  },
  leftColumn: {
    backgroundColor: '#dc3545 !important',
    background: 'none !important',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    color: '#ffffff',
    position: 'relative',
    transition: 'all 0.5s ease-in-out',
    overflow: 'hidden',
    height: '100vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'rgba(255, 255, 255, 0.1)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.3)',
      borderRadius: '4px',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.4)',
      },
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: theme.spacing(2),
      position: 'absolute',
      zIndex: 2,
      height: '100%',
      transform: 'translateX(0)',
      left: 0,
      top: 0
    },
    '& .MuiAccordion-root': {
      backgroundColor: 'transparent',
      color: '#ffffff',
      boxShadow: 'none',
      '&:before': {
        display: 'none'
      },
      '& .MuiAccordionSummary-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        minHeight: '48px',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.15)'
        },
        '& .MuiAccordionSummary-content': {
          margin: '12px 0',
          '& .MuiTypography-root': {
            color: '#ffffff',
            fontWeight: 'bold'
          }
        },
        '& .MuiAccordionSummary-expandIcon': {
          color: '#ffffff'
        }
      },
      '& .MuiAccordionDetails-root': {
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: theme.spacing(2)
      }
    }
  },
  leftColumnHidden: {
    width: '55px',
    padding: theme.spacing(1),
    backgroundColor: '#dc3545 !important',
    background: 'none !important',
    [theme.breakpoints.down('md')]: {
      width: '55px',
      padding: theme.spacing(1),
      transform: 'translateX(calc(-100% + 55px))',
      position: 'absolute',
      left: 0,
      top: 0
    },
    '& $leftColumnContent': {
      opacity: 0,
      transition: 'opacity 0.5s ease-in-out'
    }
  },
  leftColumnContent: {
    marginBottom: '60px',
    transition: 'opacity 0.2s ease-in-out'
  },
  rightColumn: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    flex: 1,
    minWidth: 0,
    transition: 'width 0.3s',
    position: 'relative',
    overflow: 'auto'
  },
  rightColumnContent: {
    height: '100%',
    overflowY: 'auto',
    paddingBottom: '80px'
  },
  rightColumnExpanded: {
    width: 'calc(100% - 70px)',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: theme.spacing(2, 2, 2, 2),
      position: 'relative',
      zIndex: 1,
      marginLeft: '0',
      transform: 'translateX(0)',
      background: '#ffffff'
    }
  },
  serviceTitle: {
    color: '#ffffff',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3),
    fontFamily: 'Montserrat, sans-serif',
    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
  },
  serviceDescription: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#ffffff',
    marginBottom: theme.spacing(4),
    opacity: 0.9,
    fontFamily: 'Montserrat, sans-serif'
  },
  serviceFeatures: {
    listStyle: 'none',
    padding: 0,
    '& li': {
      marginBottom: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      '& i': {
        color: '#ffffff',
        marginRight: theme.spacing(2),
        fontSize: '12px'
      },
      '& span': {
        color: '#ffffff',
        fontSize: '12px'
      }
    }
  },
  stepper: {
    padding: theme.spacing(3, 0, 3, 0),
    background: 'transparent',
    marginBottom: theme.spacing(2),
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  timeline: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2)
    }
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  stepCircle: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: '#cccccc',
    backgroundColor: '#cccccc',
    border: '2px solid #cccccc',
    transition: 'all 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      width: '30px',
      height: '30px',
      fontSize: '1rem'
    }
  },
  stepCircleActive: {
    backgroundColor: '#dc3545',
    color: '#ffffff',
    borderColor: '#dc3545',
    boxShadow: '0 0 10px rgba(220, 53, 69, 0.2)'
  },
  stepCircleInactive: {
    backgroundColor: '#cccccc',
    color: '#ffffff',
    borderColor: '#cccccc',
    opacity: 0.8
  },
  stepLine: {
    height: '2px',
    width: '50px',
    backgroundColor: '#cccccc',
    opacity: 0.8,
    [theme.breakpoints.down('sm')]: {
      width: '30px'
    }
  },
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(20px) scale(0.98)'
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) scale(1)'
    }
  },
  '@keyframes fadeOut': {
    from: {
      opacity: 1,
      transform: 'translateY(0) scale(1)'
    },
    to: {
      opacity: 0,
      transform: 'translateY(-20px) scale(0.98)'
    }
  },
  stepContent: {
    padding: theme.spacing(3),
    position: 'relative',
    minHeight: '300px',
    animation: 'fadeIn 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
    '&.exiting': {
      animation: 'fadeOut 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
    }
  },
  formField: {
    marginBottom: theme.spacing(3),
    position: 'relative',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      transition: 'all 0.3s ease-in-out',
      boxShadow: '0 8px 16px rgba(128, 128, 128, 0.3)',
      backgroundColor: '#ffffff',
      width: '100%',
      height: '56px',
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#dc3545',
        }
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#dc3545',
        }
      },
      '& .MuiInputBase-input': {
        padding: '16px 0 16px 45px',
        fontSize: '15px',
        color: '#333333',
        width: '100%',
        boxSizing: 'border-box',
        height: '100%'
      },
      '&.MuiInputBase-multiline': {
        padding: 0,
        height: 'auto',
        minHeight: '120px',
        maxHeight: '140px',
        '& .MuiInputBase-inputMultiline': {
          padding: '16px 0 16px 45px',
          minHeight: '120px',
          maxHeight: '140px',
          height: 'auto !important',
          overflow: 'auto !important',
          width: '100%',
          boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          height: '100%',
          minHeight: '120px',
          maxHeight: '140px',
          width: '100%',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: 'absolute'
        }
      }
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '16px 0 16px 45px !important',
      '& .MuiAutocomplete-input': {
        padding: '0 !important',
        margin: '0 !important'
      }
    },
    '& .MuiAutocomplete-endAdornment': {
      right: '8px !important'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(45px, 18px) scale(1)',
      color: '#666666',
      '&.Mui-focused': {
        color: '#dc3545'
      }
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(45px, -6px) scale(0.75)',
      backgroundColor: '#ffffff',
      padding: '0 4px'
    },
    '& .MuiFormHelperText-root': {
      marginLeft: '14px',
      color: '#dc3545',
      position: 'absolute',
      bottom: '-20px',
      left: 0,
      margin: 0,
      padding: 0
    },
    '& .input-icon': {
      position: 'absolute',
      left: '16px',
      top: '18px',
      color: '#dc3545',
      fontSize: '20px',
      transition: 'all 0.3s ease-in-out',
      zIndex: 1,
      pointerEvents: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      height: 'auto',
      lineHeight: 1
    },
    '& .MuiMenuItem-root': {
      color: '#333333',
      padding: '8px 16px',
      minHeight: 'auto',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(220, 53, 69, 0.08)'
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(220, 53, 69, 0.12)',
        '&:hover': {
          backgroundColor: 'rgba(220, 53, 69, 0.16)'
        }
      }
    },
    '& .MuiSelect-select': {
      padding: '16px 0 16px 45px',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      minHeight: '56px',
      boxSizing: 'border-box'
    }
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
    position: 'sticky',
    bottom: 0,
    right: 0,
    width: '60%',
    boxSizing: 'border-box',
    gap: theme.spacing(1.25),
    marginLeft: '10px',
    boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
    zIndex: 1000,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      right: 'auto',
      left: 0,
      flexDirection: 'row',
      gap: theme.spacing(1.25),
      marginLeft: '10px'
    }
  },
  formContainer: {
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '80px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
  },
  button: {
    margin: theme.spacing(1),
    padding: theme.spacing(1),
    minWidth: '40px !important',
    width: '40px !important',
    height: '40px !important',
    borderRadius: '50% !important',
    boxShadow: 'none',
    marginRight: '10px !important',
    [theme.breakpoints.down('sm')]: {
      minWidth: '35px !important',
      width: '35px !important',
      height: '35px !important',
      padding: theme.spacing(0.5)
    },
    '&.MuiButton-contained': {
      backgroundColor: '#dc3545',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: '#c82333'
      }
    },
    '&.MuiButton-outlined': {
      backgroundColor: '#dc3545',
      border: 'none',
      color: '#ffffff',
      '&:hover': {
        color: '#ffffff',
        backgroundColor: '#c82333',
        border: 'none'
      },
      '& .MuiButton-label': {
        '& i': {
          color: '#ffffff'
        }
      }
    },
    '&:last-child': {
      marginRight: 0
    }
  },
  summaryContainer: {
    marginTop: theme.spacing(10),
    padding: theme.spacing(3),
    background: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    '& > *': {
      animation: 'fadeIn 0.5s ease-out forwards',
      opacity: 0,
      transform: 'translateY(20px)',
      '&:nth-child(1)': { animationDelay: '0.1s' },
      '&:nth-child(2)': { animationDelay: '0.2s' },
      '&:nth-child(3)': { animationDelay: '0.3s' },
      '&:nth-child(4)': { animationDelay: '0.4s' }
    }
  },
  summaryTitle: {
    color: '#dc3545',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    position: 'relative',
    fontFamily: 'Montserrat, sans-serif',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '50px',
      height: '3px',
      background: '#dc3545',
      borderRadius: '2px'
    }
  },
  summaryItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: '#f8f9fa',
    borderRadius: '8px',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      background: '#f1f3f5',
      transform: 'translateX(5px)'
    }
  },
  summaryLabel: {
    color: '#6c757d',
    fontWeight: 'bold',
    fontSize: '1rem',
    fontFamily: 'Montserrat, sans-serif'
  },
  summaryValue: {
    color: '#212529',
    fontSize: '1.1rem',
    fontWeight: '500',
    fontFamily: 'Montserrat, sans-serif'
  },
  downloadButton: {
    marginBottom: theme.spacing(3),
    backgroundColor: '#6c757d',
    color: '#ffffff',
    padding: theme.spacing(1.5, 3),
    borderRadius: '8px',
    fontWeight: 'bold',
    textTransform: 'none',
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(3),
    '&:hover': {
      backgroundColor: '#5a6268'
    },
    '& .MuiButton-startIcon': {
      marginRight: theme.spacing(1)
    }
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    '& .MuiCircularProgress-root': {
      color: '#dc3545'
    }
  },
  accordion: {
    marginBottom: theme.spacing(2),
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
    '&:before': {
      display: 'none'
    },
    backgroundColor: 'rgba(255,255,255,0.1)',
    backdropFilter: 'blur(5px)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderLeft: '4px solid #ffc107 !important',
    '& .MuiAccordionSummary-root': {
      borderLeft: '4px solid #ffc107 !important',
      backgroundColor: 'rgba(255,255,255,0.1)',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.15)'
      }
    },
    '& .MuiAccordionDetails-root': {
      borderLeft: '4px solid #ffc107 !important',
      backgroundColor: 'rgba(255,255,255,0.05)',
      borderTop: '1px solid rgba(255,255,255,0.1)'
    }
  },
  accordionSummary: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    '& .MuiAccordionSummary-content': {
      margin: theme.spacing(2, 0),
      display: 'flex',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
      opacity: 1
    }
  },
  accordionDetails: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(255,255,255,0.05)',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    '& .MuiTypography-root': {
      color: '#ffffff',
      fontSize: '14px'
    },
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      '& li': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        '& i': {
          color: '#ffffff',
          marginRight: theme.spacing(1),
          fontSize: '14px'
        },
        '& span': {
          color: '#ffffff',
          fontSize: '14px'
        }
      }
    }
  },
  serviceIcon: {
    marginRight: theme.spacing(2),
    color: '#ffffff',
    fontSize: '1.5rem',
    opacity: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px'
  },
  accordionTitle: {
    color: '#ffffff !important',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    opacity: 1,
    textShadow: '0 1px 2px rgba(0,0,0,0.2)',
    fontFamily: 'Montserrat, sans-serif'
  },
  serviceFeatures: {
    marginTop: theme.spacing(2),
    '& li': {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
      '& i': {
        color: '#ffffff',
        marginRight: theme.spacing(1),
        fontSize: '0.9rem',
        opacity: 0.8
      }
    }
  },
  toggleButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    zIndex: 3
  },
  logoSection: {
    padding: 0,
    marginBottom: theme.spacing(6),
    position: 'relative',
    height: '60px',
    display: 'flex',
    alignItems: 'center'
  },
  logo: {
    height: '60px',
    width: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))',
    position: 'absolute',
    left: '-5px',
    top: '-4px'
  },
  accordionButton: {
    backgroundColor: '#ffffff',
    color: '#dc3545',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    padding: theme.spacing(2),
    border: '3px solid #ffc107 !important',
    borderRadius: '8px',
    marginBottom: theme.spacing(2),
    boxShadow: '0 2px 4px rgba(255, 193, 7, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(220, 53, 69, 0.04)',
      borderColor: '#ffca2c !important',
      boxShadow: '0 4px 8px rgba(255, 193, 7, 0.3)'
    },
    '& .MuiAccordionSummary-content': {
      margin: 0
    }
  },
  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: '2px solid #dc3545'
  },
  logo: {
    height: '60px',
    marginRight: theme.spacing(3)
  },
  companyInfo: {
    flex: 1
  },
  companyName: {
    color: '#dc3545',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    marginBottom: theme.spacing(1),
    fontFamily: 'Montserrat, sans-serif'
  },
  companyDetails: {
    color: '#6c757d',
    fontSize: '0.9rem',
    lineHeight: 1.5,
    fontFamily: 'Montserrat, sans-serif'
  },
  whatsappButton: {
    backgroundColor: '#25D366',
    color: '#ffffff',
    marginLeft: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#128C7E'
    }
  },
  summaryPaper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    '& .MuiTypography-subtitle1': {
      color: '#dc3545',
      fontWeight: 'bold',
      marginBottom: theme.spacing(1)
    },
    '& .MuiTypography-body1': {
      color: '#333333',
      marginBottom: theme.spacing(0.5)
    }
  },
  stepTitle: {
    fontSize: '0.9rem',
    fontWeight: 500,
    color: '#cccccc',
    textAlign: 'center',
    opacity: 0.8,
    fontFamily: 'Montserrat, sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem'
    }
  },
  stepTitleActive: {
    color: '#dc3545',
    opacity: 1,
    fontWeight: 600,
    fontFamily: 'Montserrat, sans-serif'
  },
  stepTitleInactive: {
    color: '#cccccc',
    opacity: 0.8,
    fontFamily: 'Montserrat, sans-serif'
  },
  infoPaper: {
    padding: theme.spacing(2),
    backgroundColor: 'rgba(255, 193, 7, 0.1)',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    transition: 'all 0.3s ease-in-out',
    border: '1px solid #ffc107',
    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
    },
    '& .MuiTypography-subtitle1': {
      color: '#dc3545',
      fontWeight: 'bold',
      marginBottom: theme.spacing(1)
    },
    '& .MuiTypography-body1': {
      color: '#333333',
      marginBottom: theme.spacing(0.5)
    }
  },
  infoTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.9rem',
    fontFamily: 'Montserrat, sans-serif',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      display: 'none'
    }
  },
  infoText: {
    color: '#333333',
    fontSize: '0.9rem',
    lineHeight: 1.5,
    fontFamily: 'Montserrat, sans-serif'
  },

  selectPlaceholder: {
    '& .MuiSelect-select': {
      '&:not(:focus)': {
        '&::placeholder': {
          opacity: 0
        }
      }
    }
  },
  menuItem: {
    '&.MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15) !important',
        transition: 'background-color 0.2s ease'
      }
    }
  },
  select: {
    '& .MuiSelect-select': {
      '&:focus': {
        backgroundColor: 'transparent'
      }
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15) !important',
        transition: 'background-color 0.2s ease'
      }
    }
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(3),
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      transition: 'all 0.3s ease-in-out',
      boxShadow: '0 8px 16px rgba(128, 128, 128, 0.3)',
      backgroundColor: '#ffffff',
      width: '100%',
      height: '56px',
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#dc3545',
          boxShadow: '0 12px 24px rgba(128, 128, 128, 0.4)'
        }
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#dc3545',
          boxShadow: '0 16px 32px rgba(128, 128, 128, 0.5)'
        }
      },
      '& .MuiInputBase-input': {
        padding: '16px 0 16px 45px',
        fontSize: '15px',
        color: '#333333',
        width: '100%',
        boxSizing: 'border-box',
        height: '100%'
      },
      '&.MuiInputBase-multiline': {
        padding: 0,
        height: 'auto',
        minHeight: '120px',
        maxHeight: '140px',
        '& .MuiInputBase-inputMultiline': {
          padding: '16px 0 16px 45px',
          minHeight: '120px',
          maxHeight: '140px',
          height: 'auto !important',
          overflow: 'auto !important',
          width: '100%',
          boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          height: '100%',
          minHeight: '120px',
          maxHeight: '140px',
          width: '100%',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          position: 'absolute'
        }
      }
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '16px 0 16px 45px !important',
      '& .MuiAutocomplete-input': {
        padding: '0 !important',
        margin: '0 !important'
      }
    },
    '& .MuiAutocomplete-endAdornment': {
      right: '8px !important'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(45px, 18px) scale(1)',
      color: '#666666',
      '&.Mui-focused': {
        color: '#dc3545'
      }
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(45px, -6px) scale(0.75)',
      backgroundColor: '#ffffff',
      padding: '0 4px'
    },
    '& .MuiFormHelperText-root': {
      marginLeft: '14px',
      color: '#dc3545',
      position: 'absolute',
      bottom: '-20px',
      left: 0,
      margin: 0,
      padding: 0
    },
    '& .input-icon': {
      position: 'absolute',
      left: '16px',
      top: '18px',
      color: '#dc3545',
      fontSize: '20px',
      transition: 'all 0.3s ease-in-out',
      zIndex: 1,
      pointerEvents: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      height: 'auto',
      lineHeight: 1
    },
    '& .MuiMenuItem-root': {
      color: '#333333',
      padding: '8px 16px',
      minHeight: 'auto',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: 'rgba(220, 53, 69, 0.08)'
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(220, 53, 69, 0.12)',
        '&:hover': {
          backgroundColor: 'rgba(220, 53, 69, 0.16)'
        }
      }
    },
    '& .MuiSelect-select': {
      padding: '16px 0 16px 45px',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      minHeight: '56px',
      boxSizing: 'border-box'
    }
  },
  cargoDescriptionPaper: {
    backgroundColor: '#fff3cd',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    marginBottom: 0,
    borderLeft: '4px solid #ffc107',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(0.5)
    }
  },
  cargoDescriptionPaperDanger: {
    backgroundColor: '#fff3f3',
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    marginBottom: 0,
    borderLeft: '4px solid #dc3545',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(0.5)
    }
  },
  cargoDescriptionText: {
    color: '#856404',
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem'
    }
  },
  cargoDescriptionTextDanger: {
    color: '#dc3545',
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem'
    }
  },
}));

const CotizadorForm = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [isLeftColumnVisible, setIsLeftColumnVisible] = useState(window.innerWidth > 1024);
  const [esEjecutivo, setEsEjecutivo] = useState(false);
  const {
    isGlobalLoading,
    servicios,
    errorDialogGlobal,
    successDialogGlobal,
    ejecutivos,
    puertos,
    comunasDestino,
    tiposCargas,
    tiposContenedores,
    tiposIncoterms,
    cotizacion,
    cotizacionErrors,
    numeroWhatsapp,
    serviciosValores
  } = useSelector(({ Cotizador20 }) => Cotizador20);

  const [errors, setErrors] = useState(cotizacionErrors);
  const [activeStep, setActiveStep] = useState(1);
  const [showTipoDeServicioInfo, setShowTipoDeServicioInfo] = useState(false);
  const [showTipoDeCargaInfo, setShowTipoDeCargaInfo] = useState(false);
  const [showCargaPeligrosaDialog, setShowCargaPeligrosaDialog] = useState(false);
  const [showContenedorInfo, setShowContenedorInfo] = useState(false);
  const [showIncotermInfo, setShowIncotermInfo] = useState(false);
  const [isAccepting, setIsAccepting] = useState(false);
  const [acceptSuccess, setAcceptSuccess] = useState(false);
  const [acceptError, setAcceptError] = useState(null);
  const [showConfirmAcceptCotizacionDialog, setShowConfirmAcceptCotizacionDialog] = useState(false);
  const [comoCalcular, setComoCalcular] = useState('');

  const LoadingOverlay = ({ show }) => {
    const classes = useStyles();
    if (!show) return null;

    return (
      <div className={classes.loadingOverlay}>
        <img
          src="/LogoBlanco.png"
          alt="Loading..."
          className={classes.loadingLogo}
        />
      </div>
    );
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : null);
  };

  useEffect(() => {

    // vamos a setear un newerror y revisar todo el cotizacion y limpiar los errores de los campos que no esten vacios
    const newErrors = { ...errors };

    // vamos a recorrer el cotizacion y limpiar los errores de los campos que no esten vacios
    Object.keys(cotizacion).forEach(key => {
      if (cotizacion[key] !== null && cotizacion[key] !== undefined && cotizacion[key].toString().trim() !== '' && cotizacion[key].length > 0) {
        newErrors[key] = '';
      }
    });

    // ahora seteamos el newerrors en el reducer
    setErrors(newErrors);

  }, [cotizacion]);

  const handleAcceptCotizacion = () => {
    setIsAccepting(true);

    console.log('vamos a encriptar el id de la cotizacion', cotizacion.id);
    const key = Buffer.from(envConfig.enviroment.ENCRYPTION_KEY, 'hex');
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv(envConfig.enviroment.ALGORITHM, key, iv);
    const idString = String(cotizacion.id);
    let encrypted = cipher.update(idString, 'utf8', 'base64');
    encrypted += cipher.final('base64');
    const combined = Buffer.concat([iv, Buffer.from(encrypted, 'base64')]);
    const encryptedId = combined.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    // --- End Encryption --- 

    console.log("ID Encriptado para aceptación:", encryptedId);    
    dispatch(fetchCotizacion20Accept(encryptedId));
  };

  const handleLogoClick = () => {
    // quiero que reacarges la pagina forzando un refresh y clear el local storage
    window.location.reload();
    localStorage.clear();
  };

  const toggleLeftColumn = () => {
    setIsLeftColumnVisible(!isLeftColumnVisible);
  };

  const handleErrorDialogGlobalClose = () => {
    dispatch(fetchSetErrorDialogGlobal({ open: false }));
  };

  const handleErrorDialogGlobalOpen = () => {
    dispatch(fetchSetErrorDialogGlobal({ open: true, title: 'Error', message: 'Ha ocurrido un error inesperado.' }));
  };

  const handleSuccessDialogGlobalClose = () => {
    dispatch(fetchSetSuccessDialogGlobal({ open: false }));
  };

  const handleSuccessDialogGlobalOpen = () => {
    dispatch(fetchSetSuccessDialogGlobal({ open: true }));
  };

  // ahora al cargar la pagina por primera vez si la variable servicios del reducer esta null o vacia ejecutare el dispatch de fetchGetServiciosRequest
  useEffect(() => {

    // si la variable servicios del reducer esta null o vacia ejecutare el dispatch de fetchGetServiciosRequest
    if (!servicios || servicios.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetServiciosRequest());
    }

    //si la variable ejecutivos del reducer esta null o vacia ejecutare el dispatch de fetchGetEjecutivosRequest
    if (!ejecutivos || ejecutivos.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetEjecutivosRequest());
    }

    //si la variable puertos del reducer esta null o vacia ejecutare el dispatch de fetchGetPuertosRequest
    if (!puertos || puertos.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetPuertosRequest());
    }

    //si la variable comunasDestino del reducer esta null o vacia ejecutare el dispatch de fetchGetComunasDestinoRequest
    if (!comunasDestino || comunasDestino.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetComunasDestinoRequest());
    }

    //si la variable tiposCargas del reducer esta null o vacia ejecutare el dispatch de fetchGetTiposCargasRequest
    if (!tiposCargas || tiposCargas.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetTiposCargasRequest());
    }

    //si la variable tiposContenedores del reducer esta null o vacia ejecutare el dispatch de fetchGetTiposContenedoresRequest
    if (!tiposContenedores || tiposContenedores.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetTiposContenedoresRequest());
    }

    //si la variable tiposIncoterms del reducer esta null o vacia ejecutare el dispatch de fetchGetTiposIncotermsRequest
    if (!tiposIncoterms || tiposIncoterms.length === 0) {
      dispatch(showGlobalLoading());
      dispatch(fetchGetTiposIncotermsRequest());
    }

    // ahora seteamos el valor de serviciosValores en el reducer
    if (!serviciosValores || serviciosValores.length === 0) {
      dispatch(fetchGetServiciosValoresRequest());
    } 

    // ahora necesitamos reconocer la urj actual, si tiene el string cotizador20ejecutivo setEsEjecutivo a true, si no setEsEjecutivo a false
    if (window.location.href.includes('cotizador20ejecutivo')) {
      setEsEjecutivo(true);
    } else {
      setEsEjecutivo(false);
    }
  }, []);


  const handleStepChange = (actualStep, event) => {
    const newErrors = { ...errors };
    // vamos a limpiar todos los errores de todos los datos
    Object.keys(newErrors).forEach(key => {
      newErrors[key] = '';
    });

    if (event === 'next' && actualStep === 1) {

      // si el cotizacion.id es 0 entonces cotizacion.estado es NUEVA
      if (cotizacion.id === 0) {
        cotizacion.fk_estado = 1;
      }
      else if (cotizacion.id > 0) {
        cotizacion.fk_estado = 2;
      }

      // ahora vamos a validar los campos, dependiendo de la url ejecutivo o cliente
      if (esEjecutivo) {

        if (cotizacion.fk_ejecutivo === null || cotizacion.fk_ejecutivo === undefined || cotizacion.fk_ejecutivo <= 0) {
          newErrors.fk_ejecutivo = 'El ejecutivo es requerido.';
        } else {
          newErrors.fk_ejecutivo = '';
        }

        if (cotizacion.fk_cliente === null || cotizacion.fk_cliente === undefined || cotizacion.fk_cliente.length <= 0) {
          newErrors.fk_cliente = 'El cliente es requerido.';
        } else {
          newErrors.fk_cliente = '';
        }
      }

      if (cotizacion.contacto_nombre === null || cotizacion.contacto_nombre === undefined || cotizacion.contacto_nombre.trim() === '' || cotizacion.contacto_nombre.length <= 0) {
        newErrors.contacto_nombre = 'El nombre del contacto es requerido.';
      } else {
        newErrors.contacto_nombre = '';
      }

      if (cotizacion.contacto_apellido === null || cotizacion.contacto_apellido === undefined || cotizacion.contacto_apellido.trim() === '' || cotizacion.contacto_apellido.length <= 0) {
        newErrors.contacto_apellido = 'El apellido del contacto es requerido.';
      } else {
        newErrors.contacto_apellido = '';
      }

      if (cotizacion.contacto_telefono === null || cotizacion.contacto_telefono === undefined || cotizacion.contacto_telefono.trim() === '') {
        newErrors.contacto_telefono = 'El teléfono es requerido.';
      }
      else if (!isValidPhone(cotizacion.contacto_telefono)) {
        newErrors.contacto_telefono = 'El teléfono debe iniciar con +56.';
      }
      else if (cotizacion.contacto_telefono.length < 10) {
        newErrors.contacto_telefono = 'El teléfono debe tener al menos 10 dígitos.';
      }
      else {
        newErrors.contacto_telefono = '';
      }

      if (cotizacion.contacto_correo === null || cotizacion.contacto_correo === undefined || cotizacion.contacto_correo.trim() === '' || cotizacion.contacto_correo.length <= 0) {
        newErrors.contacto_correo = 'El contacto_correo electrónico es requerido.';
      } else if (!isValidEmail(cotizacion.contacto_correo)) {
        newErrors.contacto_correo = 'El contacto_correo electrónico no es válido.';
      } else {
        newErrors.contacto_correo = '';
      }
    }
    else if (event === 'next' && actualStep === 2) {
      if (cotizacion.fk_tipo_servicio === null || cotizacion.fk_tipo_servicio === undefined || cotizacion.fk_tipo_servicio.toString() === "0") {
        newErrors.fk_tipo_servicio = 'El tipo de servicio es requerido.';
      } else {
        newErrors.fk_tipo_servicio = '';
      }

      if (cotizacion.fk_tipo_servicio === 2) {
        if (cotizacion.fk_tipo_contenedor === null || cotizacion.fk_tipo_contenedor === undefined || cotizacion.fk_tipo_contenedor.toString() === "0") {
          newErrors.fk_tipo_contenedor = 'El tipo de contenedor es requerido.';
        } else {
          newErrors.fk_tipo_contenedor = '';
        }

        if (cotizacion.fk_puerto_origen === null || cotizacion.fk_puerto_origen === undefined || cotizacion.fk_puerto_origen.toString() === "0") {
          newErrors.fk_puerto_origen = 'El puerto de origen es requerido.';
        } else {
          newErrors.fk_puerto_origen = '';
        }

        if (cotizacion.fk_incoterm === null || cotizacion.fk_incoterm === undefined || cotizacion.fk_incoterm.toString() === "0") {
          newErrors.fk_incoterm = 'El incoterm es requerido.';
        } else {
          newErrors.fk_incoterm = '';
        }

        if (cotizacion.valor_producto === null || cotizacion.valor_producto === undefined || cotizacion.valor_producto.toString() === "0") {
          newErrors.valor_producto = 'El valor del incoterm es requerido.';
        } else {
          newErrors.valor_producto = '';
        }
      }
      else if (cotizacion.fk_tipo_servicio === 1) {
        if (cotizacion.carga_volumen === null || cotizacion.carga_volumen === undefined || cotizacion.carga_volumen.toString() === "0") {
          newErrors.carga_volumen = 'El carga_volumen es requerido.';
        } else {
          newErrors.carga_volumen = '';
        }

        if (cotizacion.carga_peso === null || cotizacion.carga_peso === undefined || cotizacion.carga_peso.toString() === "0") {
          newErrors.carga_peso = 'El carga_peso es requerido.';
        } else {
          newErrors.carga_peso = '';
        }

      }

      if (cotizacion.fk_tipo_carga === null || cotizacion.fk_tipo_carga === undefined || cotizacion.fk_tipo_carga.toString() === "0") {
        newErrors.fk_tipo_carga = 'El tipo de carga es requerido.';
      } else {
        newErrors.fk_tipo_carga = '';
      }

      if (cotizacion.carga_detalles === null || cotizacion.carga_detalles === undefined || cotizacion.carga_detalles.length === 0) {
        newErrors.carga_detalles = 'El detalle de la carga es requerido.';
      } else {
        newErrors.carga_detalles = '';
      }
    }
    setErrors(newErrors);

    // si todos los errores estan vacios, entonces voy a la siguiente etapa
    if (event === 'next' && Object.values(newErrors).every(error => error === '')) {

      // anotes de ejecutar el step vamos a tomar toda la informacion de la cotizacion y la enviaremos a la api cotizacion20save
      if (event === 'next') {
        if (activeStep === 1) {
          dispatch(fetchCotizacion20Save(cotizacion));
        }
        else if ( activeStep === 2) {
          calcularServicioNeto();
        }
        setActiveStep(activeStep + 1);
      }
    }
    else if (event === 'back') {
      setActiveStep(activeStep - 1);
    }


    // ahora vamos a actualizar el cotizacion en el reducer, para que se actualice el estado  
  };

  const calcularServicioNeto = () => {
    // vamos a copiar el cotizacion del reducer en una variable local
    const cotizacionLocal = { ...cotizacion };

    // inicializamos todas las variables que usaremos 
    var idTipoContenedor = 0;
    
    var valor_producto = 0;
    var valor_flete = 0;
    var valor_seguro = 0;
    var valor_gestion_china = 0;
    var valor_flete_china = 0;
    var valor_margen = 0;
    var valor_aforo = 0;
    var valor_afecto=0;
    var valor_exento=0;
    var valor_neto = 0;
    var valor_iva = 0;
    var valor_total = 0;
    var valor_base = 0;
    var unidades = 0;

    if (cotizacionLocal.fk_tipo_servicio.toString() === '1') 
    {
      setComoCalcular(' (carga_volumen o (carga_peso/Factor) * unidadesACobrar) + ( Si FactorUnidades < unidadesACobrar ) + valorBaseUsd');

      var mts_desde = 0;
      var mts_hasta = 0;
      var cmb_peso = 0;
      var unidades_a_cobrar = 0;
      var valor_unitario_usd = 0;
      var valor_base_usd = 0;
      var factor_unidades = 0;
      var valor_total_usd = 0;
      // ahora vamos a sacar los valores del serviciosValores donde el cotizacionLocal.carga_volumen este entre serviciosValores.mtsDesde y serviciosValores.mtsHasta
      const serviciosValoresLocal = serviciosValores.find(servicio => servicio.mts_desde <= cotizacionLocal.carga_volumen && cotizacionLocal.carga_volumen <= servicio.mts_hasta);

      if( serviciosValoresLocal ) {
        mts_desde = serviciosValoresLocal.mts_desde;
        mts_hasta = serviciosValoresLocal.mts_hasta;
        cmb_peso = serviciosValoresLocal.cmb_peso;
        unidades_a_cobrar = serviciosValoresLocal.unidades_a_cobrar;
        valor_unitario_usd = serviciosValoresLocal.valor_unitario_usd;
        valor_base_usd = serviciosValoresLocal.valor_base_usd; 
        valor_iva = serviciosValoresLocal.iva;
        valor_base = serviciosValoresLocal.valor_unitario_usd;
        valor_afecto=serviciosValoresLocal.afecto;
        valor_exento=serviciosValoresLocal.exento;
      }

      // ahora vamos a calcular que es mayor, si el (cotizacionLocal.carga_volumen/cmbPeso) o el cotizacionLocal.carga_volumen
      if( cotizacionLocal.carga_volumen/cmb_peso > cotizacionLocal.carga_volumen ) {
        factor_unidades = cotizacionLocal.carga_volumen/cmb_peso;
      }
      else {
        factor_unidades = cotizacionLocal.carga_volumen;
      }

      valor_total_usd = factor_unidades * valor_unitario_usd; 

      if( factor_unidades < unidades_a_cobrar ) {
        valor_total_usd = valor_base_usd;
      }

      cotizacionLocal.valor_producto = valor_producto; 
      cotizacionLocal.valor_flete = valor_flete;
      cotizacionLocal.valor_seguro = valor_seguro;
      cotizacionLocal.valor_gestion_china = valor_gestion_china;
      cotizacionLocal.valor_flete_china = valor_flete_china;
      cotizacionLocal.valor_margen = valor_margen;
      cotizacionLocal.valor_aforo = valor_aforo; 
      cotizacionLocal.valor_neto = Number(valor_total_usd);
      cotizacionLocal.valor_iva = Number(cotizacionLocal.carga_volumen) * (Number(valor_afecto) * (Number(valor_iva)/100));
      cotizacionLocal.valor_total = Number(valor_total_usd) + Number(cotizacionLocal.valor_iva);
      cotizacionLocal.valor_base = valor_unitario_usd;
      cotizacionLocal.unidades = factor_unidades;
      // ahora con la informacion actualizada vamos al save de la cotizacion
      dispatch(fetchCotizacion20Save(cotizacionLocal));

      dispatch(fetchSetCotizacion({ ...cotizacion, valor_producto: valor_producto, valor_flete: valor_flete, valor_seguro: valor_seguro, valor_gestion_china: valor_gestion_china, valor_flete_china: valor_flete_china, valor_margen: valor_margen, valor_aforo: valor_aforo, valor_neto: valor_neto, valor_iva: valor_iva, valor_total: valor_total, valor_base: valor_base, unidades: unidades }));

      dispatch(fetchCotizacion20Save(cotizacionLocal));

      console.log('cotizacionLocal ', JSON.stringify(cotizacionLocal));
    }
    else if(cotizacionLocal.fk_tipo_servicio.toString()==='2'){
        // vamos a obtener toda la informacion del tipo de servicio
        const tipoServicio = servicios.find(servicio => servicio.id.toString() === cotizacionLocal.fk_tipo_servicio.toString() );
        console.log('tipoServicio', tipoServicio);
        // vamos a obtener el tipo de contenedor del array de tipos de contenedores
        const tipoContenedor = tiposContenedores.find(contenedor => contenedor.id.toString() === cotizacionLocal.fk_tipo_contenedor.toString() );
        console.log('tipoContenedor', tipoContenedor);

        if( cotizacionLocal.fk_tipo_contenedor.toString() === '1' ) {
          valor_aforo = tipoServicio.valor_aforo_cont_20; 
        }
        else if( cotizacionLocal.fk_tipo_contenedor.toString() === '2' ) {
          valor_aforo = tipoServicio.valor_aforo_cont_40HQ;
        }
        else if( cotizacionLocal.fk_tipo_contenedor.toString() === '3' ) {
          valor_aforo = tipoServicio.valor_aforo_cont_40NOR;
        }

        idTipoContenedor = cotizacionLocal.fk_tipo_contenedor;
        valor_flete = tipoContenedor.valor_flete;
        valor_seguro = tipoContenedor.valor_seguro / 100;
        valor_gestion_china = tipoContenedor.valor_gestion_china;
        valor_margen = tipoContenedor.valor_margen;

        // el array puertos tiene id, nombre, estado, valor20, valor40, vamos a sacar el valor20 y valor40
        const puertoOrigen = puertos.find(puerto => puerto.id === cotizacionLocal.fk_puerto_origen);
        if( idTipoContenedor === 1) {
          valor_flete_china = puertoOrigen.valor20;
        }
        else if( idTipoContenedor === 2 || idTipoContenedor === 3) {
          valor_flete_china = puertoOrigen.valor40;
        }

        console.log('vamos a calcular el servicio neto de la cotizacion', cotizacionLocal.fk_tipo_servicio, cotizacionLocal.fk_tipo_contenedor);
              
        valor_producto = cotizacionLocal.valor_producto;
        console.log('valorProducto', valor_producto);

        // calculamos el valor para FCA
        if( cotizacionLocal.fk_incoterm.toString() === '1') {
          // vamos a calcular el servicio neto de la cotizacion
          valor_neto = Number(valor_producto) + Number(valor_flete) + Number(valor_gestion_china) + Number(valor_aforo) + (Number(valor_producto) * Number(valor_seguro));
          setComoCalcular('1. Valor Producto + Valor Flete + Valor Gestión China + Valor Aforo + (Valor Producto * Valor Seguro)');
        }
        // calculamos el valor para FOB
        else if( cotizacionLocal.fk_incoterm.toString() === '2') {
          // vamos a calcular el servicio neto de la cotizacion
          valor_neto = Number(valor_producto) + Number(valor_flete) + Number(valor_aforo) + (Number(valor_producto) * Number(valor_seguro));
          setComoCalcular('2. Valor Producto + Valor Flete + Valor Aforo + (Valor Producto * Valor Seguro)');
        }
        // calculamos el valor para EXW
        else if( cotizacionLocal.fk_incoterm.toString() === '3') {
          // vamos a calcular el servicio neto de la cotizacion
          valor_neto = Number(valor_producto) + Number(valor_flete_china) + Number(valor_flete) + Number(valor_margen) + Number(valor_aforo) + (Number(valor_producto) * Number(valor_seguro));
          setComoCalcular('3. Valor Producto + Valor Flete China + Valor Flete + Valor Margen + Valor Aforo + (Valor Producto * Valor Seguro)');
        }
  
        valor_iva = valor_neto * 0.19;
        valor_total = valor_neto + valor_iva;
  
        cotizacionLocal.valor_producto = valor_producto;
        cotizacionLocal.valor_flete = valor_flete;
        cotizacionLocal.valor_seguro = valor_seguro;
        cotizacionLocal.valor_gestion_china = valor_gestion_china;
        cotizacionLocal.valor_flete_china = valor_flete_china;
        cotizacionLocal.valor_margen = valor_margen;
        cotizacionLocal.valor_aforo = valor_aforo;
        cotizacionLocal.valor_neto = valor_neto;
        cotizacionLocal.valor_iva = valor_iva;
        cotizacionLocal.valor_total = valor_total;
        cotizacionLocal.valor_base = 0;
        cotizacionLocal.unidades = unidades;
        // actualizamos el cotizacion del reducer con los nuevos valores
        dispatch(fetchSetCotizacion({ ...cotizacion, valor_producto: valor_producto, valor_flete: valor_flete, valor_seguro: valor_seguro, valor_gestion_china: valor_gestion_china, valor_flete_china: valor_flete_china, valor_margen: valor_margen, valor_aforo: valor_aforo, valor_neto: valor_neto, valor_iva: valor_iva, valor_total: valor_total, valor_base: valor_base, unidades: unidades }));

        console.log('cotizacionLocal antes del save ', cotizacionLocal);
        dispatch(fetchCotizacion20Save(cotizacionLocal));
    }
  }

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isValidPhone = (phone) => {
    // solo validamos que inicie con +56
    if (phone.startsWith('+56')) {
      return true;
    }
    else {
      return false;
    }
  };

  // en esta funcion vamos limpiar èl numero y dejarlo en un formato de clp
  const NumberFormatCustom = (value) => {
    // si el valor es null o undefined o vacio, entonces retornamos 0
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    // si el valor es un numero, entonces vamos a limpiar el numero y dejarlo en un formato de clp
    // limpiamos el numero para dejarlo en un formato compatible con float de postgres
    let cleanValue = value.replace(/[.,]/g, '');
    // ahora convertimos el valor a un numero float
    let floatValue = parseFloat(cleanValue);

    // ahora el valor float lo dejamos en formato chileno usamos el . para separador de miles y la , para separador de decimales
    let formattedValue = floatValue.toLocaleString('es-CL');

    // ahora retornamos el valor formateado
    return formattedValue;

  };

  const formatFecha = (date) => {
    return date.toISOString().replace('T', ' ').replace('Z', '-04');
  };
  
  const handleOnchage = (event, field) => {
    
    console.log('field', field);
    if(typeof event !== 'undefined') { console.log('event', event); }
    if (typeof event.id !== 'undefined') { console.log('event.id', event.id); }
    if (typeof event.target !== 'undefined') { console.log('event.target.value', event.target?.value); }

    let value;

    if ( 
      field === 'fk_ejecutivo' || 
      field === 'fk_cliente' || 
      field === 'carga_volumen' || 
      field === 'carga_peso' || 
      field === 'contacto_nombre' || 
      field === 'contacto_apellido' || 
      field === 'contacto_correo' || 
      field === 'contacto_telefono' || 
      field === 'fk_tipo_servicio' || 
      field === 'fk_tipo_contenedor' || 
      field === 'fk_incoterm' || 
      field === 'valor_producto' || 
      field === 'fk_tipo_carga' || 
      field === 'carga_detalles'  
    )
    {
      value = event ? event.target.value : null;

      if(field === 'contacto_telefono') {
        if (!isValidPhone(event.target.value)) {
          setErrors({ ...errors, contacto_telefono: 'El teléfono no es válido.' });
        }
        else {
          setErrors({ ...errors, contacto_telefono: '' });
        }
      }

      if(field === 'contacto_correo') {
        if (!isValidEmail(event.target.value)) {
          setErrors({ ...errors, contacto_correo: 'El contacto_correo no es válido.' });
        }
        else {
          setErrors({ ...errors, contacto_correo: '' });
        }
      }
    }
    else if ( field === 'fk_puerto_origen' || field === 'fk_comuna_destino' ) {
      value = event ? event.id : null;
    }


    const cambios = { ...cotizacion }; // Inicializamos el objeto de cambios con el estado actual

    if(field === 'fk_tipo_servicio') {
      // ... código anterior ...
      // vamos a sacar los dias de dias_validez del tipoServicio
      console.log('value', value);
      const tipoServicio = servicios.find(servicio => servicio.id === value);
        
      const fechaValidez = new Date();
      fechaValidez.setDate(fechaValidez.getDate() + tipoServicio.dias_validez);
      const fechaValidezFormateada = formatFecha(fechaValidez);
      console.log('fechaValidez', fechaValidezFormateada);
      
      const fechaCotizacion = new Date();
      const fechaCotizacionFormateada = formatFecha(fechaCotizacion);
      console.log('fechaCotizacion', fechaCotizacionFormateada);
      
      // Actualizamos el objeto de cambios
      cambios.dias_validez = tipoServicio.dias_validez;
      cambios.fecha_validez = fechaValidezFormateada;
      cambios.fecha_cotizacion = fechaCotizacionFormateada;
    }

    /*
    if (field === 'fk_ejecutivo') {
      // si es ejecutivo, vamos a recorrer el arra de ejecutivos y sacar el  valor del contacto_telefono 
      const ejecutivo = ejecutivos.find(ejecutivo => ejecutivo.id === value);
      // ahora seteamos el link de whatsapp con el contacto_telefono del ejecutivo
      dispatch(fetchSetNumeroWhatsapp(ejecutivo.contacto_telefono));
    }
    else if (field === 'carga_volumen' || field === 'carga_peso' || field === 'valorProducto') {
      // siempre vamos a validar que sea un numero
      value = NumberFormatCustom(value);
    }
    else if (field === 'fk_tipo_carga') {
      // si el tipo de carga es carga peligrosa, entonces muestro el dialogo de carga peligrosa
      if (value.toString() === '3') {
        setShowCargaPeligrosaDialog(true);
      }
    }
    // voy a validar el campo y si no esta vacio limpio el error y lo seteo en el reducer
    if (value && value.toString().trim().length > 0) {
      setErrors({ ...errors, [field]: '' });
    }
    */
    // Solo un dispatch al final con todos los cambios

    cambios[field] = value; 

    dispatch(fetchSetCotizacion(cambios));
  }

  const handleShareWhatsapp = () => { 
    let salidaWhatsapp = '¡Hola! Estamos escribiendo desde el formulario de cotización de WS CARGO\n';

    salidaWhatsapp += '*Nombre:* ' + cotizacion.contacto_nombre + '\n';
    salidaWhatsapp += '*Apellido:* ' + cotizacion.contacto_apellido + '\n';
    salidaWhatsapp += '*Teléfono:* ' + cotizacion.contacto_telefono + '\n';
    salidaWhatsapp += '*Email:* ' + cotizacion.contacto_correo + '\n\n';

    const tipoServicio = servicios.find(servicio => Number(servicio.id) === Number(cotizacion.fk_tipo_servicio));
    salidaWhatsapp += '*Tipo de servicio:* ' + (tipoServicio?.nombre || '-') + '\n'; 

    if (cotizacion.fk_tipo_servicio === 1) {
        salidaWhatsapp += '*carga_volumen:* ' + cotizacion.carga_volumen + '\n'; 
        salidaWhatsapp += '*carga_peso:* ' + cotizacion.carga_peso + '\n';
    } else if (cotizacion.fk_tipo_servicio === 2) {
        const tipoContenedor = tiposContenedores.find(c => c.id === cotizacion.fk_tipo_contenedor);
        const puertoOrigen = puertos.find(p => p.id === cotizacion.fk_puerto_origen);
        const incoterm = tiposIncoterms.find(i => i.id === cotizacion.fk_incoterm);

        salidaWhatsapp += '*Tipo de contenedor:* ' + (tipoContenedor?.nombre || '-') + '\n';
        salidaWhatsapp += '*Puerto de origen:* ' + (puertoOrigen?.nombre || '-') + '\n';
        salidaWhatsapp += '*Incoterm:* ' + (incoterm?.nombre || '-') + '\n';
        salidaWhatsapp += '*Valor incoterm:* ' + cotizacion.valor_producto + '\n';
    }

    const tipoCarga = tiposCargas.find(c => c.id === cotizacion.fk_tipo_carga);
    salidaWhatsapp += '*Tipo de carga:* ' + (tipoCarga?.nombre || '-') + '\n';

    const comunaDestino = comunasDestino.find(c => c.id === cotizacion.fk_comuna_destino);
    salidaWhatsapp += '*Comuna de destino:* ' + (comunaDestino?.nombre || '-') + '\n';

    salidaWhatsapp += '*Detalle de la carga:* ' + cotizacion.carga_detalles + '\n';

    if (salidaWhatsapp.trim().length > 0) {
        const telefono = cotizacion.ejecutivo_whatsapp.replace(/\D/g, ''); // Sanitiza el teléfono
        const url = `https://web.whatsapp.com/send?phone=${telefono}&text=${encodeURIComponent(salidaWhatsapp)}`;
        window.open(url, '_blank');
    }
};


  const handleDownloadPdf = async () => {
    try {
      
      // vamos a encriptar el id de la cotizacion y lo enviaremos a una url directo del bakcend para que pueda generar el pdf
      

      const key = Buffer.from(envConfig.enviroment.ENCRYPTION_KEY, 'hex');
      const iv = crypto.randomBytes(16);
      const cipher = crypto.createCipheriv(envConfig.enviroment.ALGORITHM, key, iv);
      const idString = String(cotizacion.id);
      let encrypted = cipher.update(idString, 'utf8', 'base64');
      encrypted += cipher.final('base64');
      const combined = Buffer.concat([iv, Buffer.from(encrypted, 'base64')]);
      const encryptedId = combined.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      // --- End Encryption --- 

      console.log("ID Encriptado para aceptación:", encryptedId);    
      // vamos a abrir al url en una nueva pestaña
      window.open(envConfig.enviroment.urlApiExternal+`cotizador20/download-pdf/${encryptedId}`, '_blank');      
    } catch (error) {
      console.error('Error al generar el PDF:', error);
      // Aquí podrías mostrar un mensaje de error al usuario
    }
  }

  const handleShareEmail = () => {
      // vamos a ejecutar el dispatch para el saga de enviar contacto_correo
      dispatch(fetchSendEmailCotizacion(cotizacion));
  }

  // Tamaño responsivo para los círculos y fuente de los tabs tipo stepper
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 900;
  const circleSize = isMobile ? 28 : 40;
  const fontSize = isMobile ? 13 : 14;

  return (
    <div className={classes.root}>
      <LoadingOverlay show={isGlobalLoading} /> {/* <--- Usar isGlobalLoading de Redux */}
      <div style={{
        display: 'flex',
        width: '100%',
        height: '100vh',
      }}>
        {isLeftColumnVisible && (
          <div
            id="LeftColumn"
            className={classes.leftColumn}
            style={{
              width: isLeftColumnVisible ? '400px' : '0px',
              minWidth: isLeftColumnVisible ? '400px' : '0px',
              maxWidth: isLeftColumnVisible ? '400px' : '0px',
              position: 'relative',
              overflow: 'hidden',
              zIndex: 1,
              transition: 'width 0.3s, min-width 0.3s, max-width 0.3s',
              overflowX: 'hidden',
              overflowY: 'auto',
              scrollbarWidth: 'none'
            }}
          >
            <div
              style={{
                opacity: isLeftColumnVisible ? 1 : 0,
                transition: 'opacity 0.3s',
                pointerEvents: isLeftColumnVisible ? 'auto' : 'none',
                height: '150%'
              }}
            >
              <div className={classes.leftColumnContent} style={{ marginTop: '50px' }}>
                <div className={classes.logoSection}>
                  <img
                    src="/LogoBlanco.png"
                    alt="Logo"
                    className={classes.logoImage}
                    onClick={handleLogoClick}
                    style={{
                      cursor: 'pointer'
                    }}
                  />
                </div>
                <Typography variant="h2" className={classes.serviceTitle}>
                  Nuestros Servicios
                </Typography>
                <Typography className={classes.serviceDescription}>
                  Ofrecemos soluciones logísticas personalizadas con más de 10 años de experiencia en el sector. Selecciona el servicio que mejor se adapte a tus necesidades.
                </Typography>
                {servicios && servicios.map((servicio, index) => ( // si servicios esta lleno y tiene datos entonces muestro los servicios 
                  <Accordion
                    key={index}
                    className={classes.accordion}
                    expanded={expandedAccordion === `panel${index}`}
                    onChange={handleAccordionChange(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      className={classes.accordionSummary}
                      aria-controls={`panel${index}bh-content`}
                      id={`panel${index}bh-header`}
                    >
                      <i className={`fas ${servicio.icon} ${classes.serviceIcon}`}></i>
                      <Typography className={classes.accordionTitle}>
                        {servicio.nombre}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                      <div
                        style={{
                          marginTop: '20px'
                        }}
                      >
                        <Box className={classes.serviceDescription}>
                        <div dangerouslySetInnerHTML={{ __html: servicio.description }} />  
                        </  Box>
                        {/* vamos a mostrar features que se crea con ReactQuill */  }
                        <Box className={classes.serviceDescription}>
                        <div dangerouslySetInnerHTML={{ __html: servicio.features }} />  
                        </Box>
                      </div>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </div>
          </div>
        )}
        <div
          id="RightColumn"
          className={classes.rightColumn}
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            flex: 1,
            minWidth: 0,
            transition: 'width 0.3s',
            position: 'relative',
            overflow: 'auto',
            margin: 0,
            padding: 0,
          }}
        >
          <div style={{
            width: '100%',
            backgroundColor: '#fff',
            zIndex: 5,
            padding: '16px 0 8px 0',
            paddingTop: '35px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            position: 'sticky',
            top: 0,
            borderBottom: '2px solid #eee',
          }}>
            <Tabs
              value={activeStep}
              variant="fullWidth"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              style={{
                width: '100%',
                maxWidth: '900px',
                margin: '0 auto',
                border: 'none',
                boxShadow: 'none',
                background: 'transparent',
                display: 'flex',
                justifyContent: 'center',
                paddingRight: '10px',
              }}
              TabIndicatorProps={{ style: { display: 'none' } }}
            >
              {[1, 2, 3].map((step, idx) => (
                <Tab
                  onClick={() => setActiveStep(step)}
                  key={step}
                  value={step}
                  disableRipple
                  icon={
                    <div style={{
                      width: circleSize,
                      height: circleSize,
                      borderRadius: '50%',
                      border: `2.5px solid #dc3545`,
                      background: activeStep === step ? '#dc3545' : '#fff',
                      color: activeStep === step ? '#fff' : '#dc3545',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 'bold',
                      fontSize: isMobile ? 15 : 20,
                      margin: '0 auto 4px auto',
                      transition: 'background 0.2s, color 0.2s',
                    }}>
                      {step}
                    </div>
                  }
                  label={
                    <span style={{
                      color: activeStep === step ? '#dc3545' : '#888',
                      fontWeight: activeStep === step ? 'bold' : 'normal',
                      fontSize: fontSize,
                      marginTop: 4,
                      display: 'block',
                      textAlign: 'center',
                    }}>
                      {step === 1 ? 'Contacto' : step === 2 ? 'Carga' : 'Confirmación'}
                    </span>
                  }
                  style={{
                    minWidth: isMobile ? 60 : 80,
                    padding: 0,
                    border: 'none',
                    background: 'transparent',
                    boxShadow: 'none',
                    outline: 'none',
                    margin: isMobile ? '0 6px' : '0 16px',
                    flex: 1,
                    maxWidth: '100%',
                  }}
                />
              ))}
            </Tabs>
            <Typography
              variant="body1"
              style={{
                width: '100%',
                color: '#dc3545',
                fontSize: 'clamp(18px, 4vw, 36px)',
                lineHeight: '1.4',
                textAlign: 'center',
                maxWidth: '900px',
                margin: '0 auto',
              }}
            >
              {cotizacion.fk_estado !==3 ?
                <>
              <span style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
              }}>
                Ingresa tus datos e información de tu importación
              </span>
              <span style={{
                fontWeight: 'bold',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
              }}>
                Nosotros te ayudamos con todo el proceso
              </span>
              </>
              : cotizacion.fk_estado === 3 ?
                <>
              <span style={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
              }}>
                ¡Cotización Aceptada!
              </span>
              <span style={{
                fontWeight: 'bold',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
              }}>
                Prepárate, ¡nuestro equipo en China ya está listo para recibir tus productos!
              </span>
                </>
              : null}
            </Typography>
          </div>
          <div style={{
            boxSizing: 'border-box',
            padding: '20px',
          }}>
            
            {/* si el activeStep es 1 y es ejecutivo, mostramos el formulario de contacto */}
            <div
              style={{
                height: '100%',
                boxSizing: 'border-box',
                display: activeStep === 1 ? 'block' : 'none'
              }}>

              {esEjecutivo ? (
                <>
                  <Grid item xs={12} className={classes.noPaddingTB}>
                    <Grid container>
                      <InputLabel className={classes.selectLabel}>
                        Ejecutivo <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                    </Grid>
                    <div className={classes.formField + ' ' + classes.noPaddingTB}>
                      <i className="fas fa-user-tie input-icon" />
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={!!errors.fk_ejecutivo}
                        className={classes.formControl}
                      >
                        <Select
                          id="fk_ejecutivo"
                          name="fk_ejecutivo"
                          value={cotizacion.fk_ejecutivo || ''}
                          displayEmpty
                          onChange={(event) => handleOnchage(event, 'fk_ejecutivo')}
                        >
                          <MenuItem value="">
                            <em>Seleccione un ejecutivo</em>
                          </MenuItem>
                          {ejecutivos.map((ejecutivo) => (
                            <MenuItem key={ejecutivo.id} value={ejecutivo.id}>
                              {ejecutivo.nombre}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.fk_ejecutivo && (
                          <FormHelperText>{errors.fk_ejecutivo}</FormHelperText>
                        )}
                      </FormControl>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <InputLabel className={classes.selectLabel}>
                        ID Cliente <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                    </Grid>
                    <div className={classes.formField}>
                      <i className="fas fa-phone input-icon" />
                      <TextField
                        id="fk_cliente"
                        name="fk_cliente"
                        fullWidth
                        variant="outlined"
                        value={cotizacion.fk_cliente}
                        error={!!errors.fk_cliente}
                        helperText={errors.fk_cliente}
                        // al dar enter vamos a buscar el cliente por el id
                        onChange={(event) => handleOnchage(event, 'fk_cliente')}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            dispatch(fetchGetClienteById(cotizacion.fk_cliente));
                          }
                        }}
                      />
                    </div>
                  </Grid>
                </>
              ) : null}
              <Grid item xs={12}>
                <Grid container>
                  <InputLabel className={classes.selectLabel}>
                    Nombre de Contacto <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                </Grid>
                <div className={classes.formField}>
                  <i className="fas fa-user input-icon" />
                  <TextField
                    id="contacto_nombre"
                    name="contacto_nombre"
                    fullWidth
                    variant="outlined"
                    value={cotizacion.contacto_nombre}
                    onChange={(event) => handleOnchage(event, 'contacto_nombre')}
                    error={!!errors.contacto_nombre}
                    helperText={errors.contacto_nombre}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <InputLabel className={classes.selectLabel}>
                    Apellido de Contacto <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                </Grid>
                <div className={classes.formField}>
                  <i className="fas fa-user input-icon" />
                  <TextField
                    id="contacto_apellido"
                    name="contacto_apellido"
                    fullWidth
                    variant="outlined"
                    value={cotizacion.contacto_apellido}
                    onChange={(event) => handleOnchage(event, 'contacto_apellido')}
                    error={!!errors.contacto_apellido}
                    helperText={errors.contacto_apellido}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <InputLabel className={classes.selectLabel}>
                    Teléfono Celular <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                </Grid>
                <div className={classes.formField}>
                  <i className="fas fa-phone input-icon" />
                  <TextField
                    id="contacto_telefono"
                    name="contacto_telefono"
                    fullWidth
                    variant="outlined"
                    value={cotizacion.contacto_telefono}
                    onChange={(event) => handleOnchage(event, 'contacto_telefono')}
                    error={!!errors.contacto_telefono}
                    helperText={errors.contacto_telefono}
                  />
                </div>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <InputLabel className={classes.selectLabel}>
                    Correo Electrónico <span style={{ color: 'red' }}>*</span>
                  </InputLabel>
                </Grid>
                <div className={classes.formField}>
                  <i className="fas fa-envelope input-icon" />
                  <TextField
                    id="contacto_correo"
                    name="contacto_correo"
                    fullWidth
                    variant="outlined"
                    value={cotizacion.contacto_correo}
                    onChange={(event) => handleOnchage(event, 'contacto_correo')}
                    error={!!errors.contacto_correo}
                    helperText={errors.contacto_correo}
                  />
                </div>
              </Grid>
            </div>

            {/* si el activeStep es 2, mostramos el formulario de tipo de servicio */}
            <div
              style={{
                height: '100%',
                boxSizing: 'border-box',
                display: activeStep === 2 ? 'block' : 'none'
              }}>

              <Grid item xs={12}>
                <Grid container>
                  <InputLabel
                    className={classes.selectLabel + ' ' + classes.infoLabel}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowTipoDeServicioInfo(true);
                    }}
                  >
                    Tipo de Servicio <span style={{ color: 'red' }}>*</span>
                    <InfoIcon fontSize="small" style={{ color: '#1976d2' }} />
                  </InputLabel>
                </Grid>
                <div className={classes.formField}>
                  <i className="fas fa-truck input-icon"></i>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={!!errors.fk_tipo_servicio}
                  >
                    <Select
                      name="fk_tipo_servicio"
                      value={cotizacion.fk_tipo_servicio}
                      onChange={(event) => handleOnchage(event, 'fk_tipo_servicio')}
                      displayEmpty
                      className={classes.select}
                      MenuProps={{
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left',
                        },
                        PaperProps: {
                          style: {
                            maxHeight: 300
                          }
                        }
                      }}
                    >
                      <MenuItem key="0" value="0" className={classes.menuItem} style={{ minHeight: '48px' }}>
                        Seleccione un tipo de servicio
                      </MenuItem>
                      {servicios && servicios.length > 0 && servicios.map((servicio) => (
                        <MenuItem key={servicio.id} value={servicio.id} className={classes.menuItem} style={{ minHeight: '48px' }}>
                          {servicio.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.fk_tipo_servicio && (
                      <FormHelperText>{errors.fk_tipo_servicio}</FormHelperText>
                    )}
                  </FormControl>
                </div>
              </Grid>
              
              {
                cotizacion.fk_tipo_servicio.toString() === '1' ? (
                  <>
                  <Grid container spacing={2} className={classes.noPaddingTB}>
                    <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                      <Grid container>
                        <InputLabel
                          className={classes.selectLabel}
                        >
                          carga_volumen (m³) <span style={{ color: 'red' }}>*</span>
                        </InputLabel>
                      </Grid>
                      <div className={classes.formField}>
                        <i className="fas fa-cube input-icon"></i>
                        <TextField
                          id="carga_volumen"
                          name="carga_volumen"
                          fullWidth
                          variant="outlined"
                          value={cotizacion.carga_volumen}
                          onChange={(event) => handleOnchage(event, 'carga_volumen')}
                          error={!!errors.carga_volumen}
                          helperText={errors.carga_volumen}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                      <Grid container>
                        <InputLabel
                          className={classes.selectLabel}
                        >
                          carga_peso (kg) <span style={{ color: 'red' }}>*</span>
                        </InputLabel>
                      </Grid>
                      <div className={classes.formField}>
                        <i className="fas fa-weight input-icon"></i>
                        <TextField
                          id="carga_peso"
                          name="carga_peso"
                          fullWidth
                          variant="outlined"
                          value={cotizacion.carga_peso}
                          onChange={(event) => handleOnchage(event, 'carga_peso')}
                          error={!!errors.carga_peso}
                          helperText={errors.carga_peso} 
                        />
                      </div>
                    </Grid>
                  </Grid>
                  </>
                ) : cotizacion.fk_tipo_servicio.toString() === '2' ? (
                  <>
                    <Grid container spacing={2}>

                      <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                        <Grid container>
                          <InputLabel
                            className={classes.selectLabel + ' ' + classes.infoLabel}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowContenedorInfo(true);
                            }}
                          >
                            Tipo de Contenedor <span style={{ color: 'red' }}>*</span>
                            <InfoIcon fontSize="small" style={{ color: '#1976d2' }} />

                          </InputLabel>
                        </Grid>
                        <div className={classes.formField + ' ' + classes.noPaddingTB}>
                          <i className="fas fa-box input-icon" style={{
                            position: 'absolute',
                            left: '16px',
                            top: '18px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            height: 'auto',
                            lineHeight: 1
                          }} />
                          <FormControl
                            fullWidth
                            variant="outlined"
                            error={!!errors.fk_tipo_contenedor}
                            className={classes.formControl + ' ' + classes.noPaddingTB}
                          >
                            <Select
                              id="fk_tipo_contenedor"
                              name="fk_tipo_contenedor"
                              value={cotizacion.fk_tipo_contenedor}
                              onChange={(event) => handleOnchage(event, 'fk_tipo_contenedor')}
                              displayEmpty
                              MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                                PaperProps: {
                                  style: {
                                    maxHeight: 300
                                  }
                                }
                              }}
                            >
                              <MenuItem key="0" value="0" className={classes.menuItem} style={{ minHeight: '48px' }}>
                                Seleccione tipo de contenedor
                              </MenuItem>
                              {tiposContenedores && tiposContenedores.length > 0 && tiposContenedores.map((tipo) => (
                                <MenuItem key={tipo.id} value={tipo.id} className={classes.menuItem} style={{ minHeight: '48px' }}>
                                  {tipo.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.fk_tipo_contenedor && (
                              <FormHelperText>{errors.fk_tipo_contenedor}</FormHelperText>
                            )}
                          </FormControl>
                        </div>
                      </Grid>

                      <Grid item xs={12} sm={6} className={classes.noPaddingTB}
                        style={{
                          marginTop: '5px!important'
                        }}
                      >
                        <Grid
                          container
                          style={{
                            marginBottom: '48px!important',
                            maxHeight: '25px!important',
                            minHeight: '25px!important',
                            height: '25px!important'
                          }}
                        >
                          <InputLabel
                            className={classes.selectLabel}
                          >
                            Puerto de Origen <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                        </Grid>
                        <div className={classes.formField + ' ' + classes.noPaddingTB}>
                          <i className="fas fa-anchor input-icon" style={{ marginTop: '0' }} />
                          <Autocomplete
                            id="fk_puerto_origen"
                            name="fk_puerto_origen"
                            options={puertos}
                            getOptionLabel={(option) => option.nombre || ""} // Ensure it returns empty string for invalid options
                            value={puertos.find(port => port.id === cotizacion.fk_puerto_origen) || null} // Use new name
                            onChange={(event, newValue) => handleOnchage(newValue, 'fk_puerto_origen')} // Pass newValue directly
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="fk_puerto_origen" // Use new name
                                variant="outlined"
                                error={!!errors.fk_puerto_origen} // Use new name
                                helperText={errors.fk_puerto_origen} // Use new name
                                // Apply relevant styles directly or via classes if needed
                                className={classes.formControl} // Re-apply formControl styles if necessary
                              />
                            )}
                          />
                        </div>
                      </Grid>

                    </Grid>

                    <Grid container spacing={2} className={classes.noPaddingTB}>
                      <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                        <Grid container>
                          <InputLabel
                            className={classes.selectLabel + ' ' + classes.infoLabel}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowIncotermInfo(true);
                            }}
                          >
                            Incoterms <span style={{ color: 'red' }}>*</span>
                            <InfoIcon fontSize="small" style={{ color: '#1976d2' }} />
                          </InputLabel>
                        </Grid>
                        <div className={classes.formField} style={{ marginBottom: '0', display: 'flex', alignItems: 'center' }}>
                          <i className="fas fa-truck input-icon" style={{ marginTop: '0' }} />
                          <FormControl
                            fullWidth
                            variant="outlined"
                            error={!!errors.fk_incoterm}
                            className={classes.formControl}
                          >
                            <Select
                              name="fk_incoterm"
                              value={cotizacion.fk_incoterm}
                              onChange={(event) => handleOnchage(event, 'fk_incoterm')}
                              displayEmpty
                              className={classes.select}
                              MenuProps={{
                                getContentAnchorEl: null,
                                anchorOrigin: {
                                  vertical: 'bottom',
                                  horizontal: 'left',
                                },
                                transformOrigin: {
                                  vertical: 'top',
                                  horizontal: 'left',
                                },
                                PaperProps: {
                                  style: {
                                    maxHeight: 300
                                  }
                                }
                              }}
                            >
                              <MenuItem key="0" value="0" className={classes.menuItem} style={{ minHeight: '48px' }}>
                                Seleccione un incoterm
                              </MenuItem>
                              {tiposIncoterms && tiposIncoterms.length > 0 && tiposIncoterms.map((incoterm) => (
                                <MenuItem key={incoterm.id} value={incoterm.id} className={classes.menuItem} style={{ minHeight: '48px' }}>
                                  {incoterm.nombre}
                                </MenuItem>
                              ))}
                            </Select>
                            {errors.fk_incoterm && (
                              <FormHelperText>{errors.fk_incoterm}</FormHelperText>
                            )}
                          </FormControl>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                        <Grid container>
                          <InputLabel
                            className={classes.selectLabel + ' ' + classes.infoLabel}
                          >
                            Valor (USD) <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                        </Grid>
                        <div className={classes.formField} style={{ marginBottom: '0' }}>
                          <i className="fas fa-dollar-sign input-icon" style={{
                            color: !cotizacion.fk_incoterm ? '#6c757d' : '#dc3545'
                          }} />
                          <TextField
                            id="valor_producto"
                            name="valor_producto"
                            value={cotizacion.valor_producto}
                            onChange={(event) => handleOnchage(event, 'valor_producto')}
                            error={!!errors.valor_producto}
                            helperText={errors.valor_producto}
                            fullWidth
                            variant="outlined"
                            disabled={!cotizacion.fk_incoterm}
                            InputProps={{
                              style: !cotizacion.fk_incoterm ? {
                                backgroundColor: '#e9ecef',
                                color: '#6c757d'
                              } : {}
                            }}
                            className={classes.textField}
                          />
                        </div>
                      </Grid>
                    </Grid>

                  </>
                ) : null
              }

              {cotizacion.fk_tipo_servicio !== null && cotizacion.fk_tipo_servicio !== undefined && cotizacion.fk_tipo_servicio !== 0 ? (
                <>
                <Grid container spacing={2} className={classes.noPaddingTB}>
                  <Grid item xs={12} sm={6} className={classes.noPaddingTB}>
                    <Grid container>
                      <InputLabel
                        className={classes.selectLabel + ' ' + classes.infoLabel}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowTipoDeCargaInfo(true);
                        }}
                      >
                        Tipo de Carga <span style={{ color: 'red' }}>*</span>
                        <InfoIcon fontSize="small" style={{ color: '#1976d2' }} />
                      </InputLabel>
                    </Grid>
                    <div className={classes.formField}>
                      <i className="fas fa-box input-icon"></i>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        error={!!errors.fk_tipo_carga}
                      >
                        <Select
                          id="fk_tipo_carga"
                          name="fk_tipo_carga"
                          value={cotizacion.fk_tipo_carga}
                          onChange={(event) => handleOnchage(event, 'fk_tipo_carga')}
                          displayEmpty
                          className={classes.select}
                          MenuProps={{
                            getContentAnchorEl: null,
                            anchorOrigin: {
                              vertical: 'bottom',
                              horizontal: 'left',
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left',
                            },
                            PaperProps: {
                              style: {
                                maxHeight: 300
                              }
                            }
                          }}
                        >
                          <MenuItem key="0" value="0" className={classes.menuItem} style={{ minHeight: '48px' }}>
                            Seleccione tipo de carga
                          </MenuItem>
                          {tiposCargas && tiposCargas.length > 0 && tiposCargas.map((tipo) => (
                            <MenuItem key={tipo.id} value={tipo.id}>
                              {tipo.nombre}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.fk_tipo_carga && (
                          <FormHelperText>{errors.fk_tipo_carga}</FormHelperText>
                        )}
                      </FormControl>
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={6} className={classes.noPaddingTB}
                        style={{
                          marginTop: '5px!important'
                        }}
                      >
                        <Grid
                          container
                          style={{
                            marginBottom: '48px!important',
                            maxHeight: '25px!important',
                            minHeight: '25px!important',
                            height: '25px!important'
                          }}
                        >
                          <InputLabel
                            className={classes.selectLabel}
                          >
                            Comuna de Destino <span style={{ color: 'red' }}>*</span>
                          </InputLabel>
                        </Grid>
                        <div className={classes.formField + ' ' + classes.noPaddingTB}>
                          <i className="fas fa-anchor input-icon" style={{ marginTop: '0' }} />
                          <Autocomplete
                            id="fk_comuna_destino"
                            name="fk_comuna_destino"
                            options={comunasDestino}
                            getOptionLabel={(option) => option.nombre || ""} // Ensure it returns empty string for invalid options
                            value={comunasDestino.find(port => port.id === cotizacion.fk_comuna_destino) || null} // Use new name
                            onChange={(event, newValue) => handleOnchage(newValue, 'fk_comuna_destino')} // Pass newValue directly
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="fk_comuna_destino" // Use new name
                                variant="outlined"
                                error={!!errors.fk_comuna_destino} // Use new name
                                helperText={errors.fk_comuna_destino} // Use new name
                                // Apply relevant styles directly or via classes if needed
                                className={classes.formControl} // Re-apply formControl styles if necessary
                              />
                            )}
                          />
                        </div>
                  </Grid>
                </Grid>
                  <Grid item xs={12}>
                    <Grid container>
                      <InputLabel
                        className={classes.selectLabel}
                      >
                        Detalles de la Carga <span style={{ color: 'red' }}>*</span>
                      </InputLabel>
                    </Grid>
                    <div className={classes.formField}>
                      <i className="fas fa-info-circle input-icon"></i>
                      <TextField
                        id="carga_detalles"
                        name="carga_detalles"
                        fullWidth
                        variant="outlined"
                        value={cotizacion.carga_detalles || ''} 
                        onChange={(event) => handleOnchage(event, 'carga_detalles')}
                        error={!!errors.carga_detalles}
                        helperText={errors.carga_detalles}
                        multiline
                        rows={4}
                        rowsMax={7}
                        placeholder="Describa los detalles de su carga..."
                      />
                    </div>
                  </Grid>
                </>
              ) : null}

            </div>
            
            {/* si el activeStep es 3, mostramos el resumen de la cotizacion */}
            <div
              id="resumenCotizacion"
              style={{
                display: activeStep === 3 ? 'block' : 'none'
              }}>
              <>
                {/* mostrar el resumen del formulario de cotizacion */}
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Paper className={classes.summaryPaper} style={{ marginBottom: '2px' }}>
                      <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '2px' }}>
                        Información de la Cotización
                      </Typography>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <div style={{ display: 'flex', gap: '20px' }}>
                          <div style={{ width: '50%' }}>
                            <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Fecha cotización</Typography>
                            <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                              {/* la fecha tiene este formato cuando se imprime, 2025-06-17T17:55:56.539Z, pero se debe mostar yyyy-mm-dd */}
                              {cotizacion.fecha_cotizacion && cotizacion.fecha_cotizacion!='' ? cotizacion.fecha_cotizacion.split('T')[0] : '-'} 
                            </Typography>
                          </div>
                          <div style={{ width: '50%' }}>
                            <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Válido hasta</Typography>
                            <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                              {/* este es el formato 2025-06-17 13:46:26.393-04 imprimelo como yyyy-mm-dd */}
                              {cotizacion.fecha_validez && cotizacion.fecha_validez!='' ? cotizacion.fecha_validez.split('T')[0] : '-'}  
                            </Typography>
                          </div>
                        </div>
                        <div style={{ width: '100%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Nombre de contacto</Typography>
                          <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.contacto_nombre || '-'}</Typography>
                        </div>
                        <div style={{ width: '100%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Apellido de contacto</Typography>
                          <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.contacto_apellido || '-'}</Typography>
                        </div>                        
                        <div style={{ display: 'flex', gap: '20px' }}>
                          <div style={{ width: '50%' }}>
                            <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Email</Typography>
                            <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.contacto_correo || '-'}</Typography>
                          </div>
                          <div style={{ width: '50%' }}>
                            <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Teléfono Celular</Typography>
                            <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.contacto_telefono || '-'}</Typography>
                          </div>
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                </Grid>

                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Paper className={classes.summaryPaper} style={{ marginBottom: '2px' }}>
                      <Typography variant="subtitle1" gutterBottom style={{ marginBottom: '2px' }}>
                        Información de la Carga
                      </Typography>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {cotizacion.fk_tipo_servicio.toString() === '2' ? (
                          <>
                            <div style={{ width: '100%', marginTop: '15px', marginBottom: '10px' }}>
                              <Typography variant="body2" style={{ color: '#dc3545', fontSize: '14px', fontWeight: 'bold' }}>
                                Información con Contenedor Exclusivo
                              </Typography>
                            </div>
                            <div style={{ display: 'flex', gap: '20px' }}>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Tipo de contenedor</Typography>
                                <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{tiposContenedores.find(tipo => tipo.id === cotizacion.fk_tipo_contenedor)?.nombre || '-'}</Typography>
                              </div>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Puerto de origen</Typography>
                                <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{puertos.find(puerto => puerto.id === cotizacion.fk_puerto_origen)?.nombre || '-'}</Typography>
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: '20px' }}>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Tipo de valor</Typography>
                                <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{tiposIncoterms.find(tipo => tipo.id === cotizacion.fk_incoterm)?.nombre || '-'}</Typography>
                              </div>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Valor</Typography>
                                <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.valor_producto || '-'}</Typography>
                              </div>
                            </div>
                          </>

                        ) : cotizacion.fk_tipo_servicio.toString() === '1' ? (
                          <>
                            <div style={{ width: '100%', marginTop: '15px', marginBottom: '10px' }}>
                              <Typography variant="body2" style={{ color: '#dc3545', fontSize: '14px', fontWeight: 'bold' }}>
                                Información con Contenedor Compartido
                              </Typography>
                              <br></br>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                <div style={{ display: 'flex', gap: '20px' }}>
                                  <div style={{ width: '50%' }}>
                                    <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>carga_volumen</Typography>
                                    <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.carga_volumen ? `${cotizacion.carga_volumen*1} m³` : '-'}</Typography>
                                  </div>
                                  <div style={{ width: '50%' }}>
                                    <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>carga_peso</Typography>
                                    <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>{cotizacion.carga_peso ? `${cotizacion.carga_peso*1} kg` : '-'}</Typography>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ width: '50%' }}>
                                  <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Tipo de Carga</Typography>
                                  <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                                    {tiposCargas.find(tipo => tipo.id === cotizacion.fk_tipo_carga)?.nombre || '-'}
                                  </Typography>
                                </div>

                                <div style={{ width: '50%' }}>
                                  <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Comuna de Destino</Typography>
                                  <Typography variant="body1" style={{ paddingBottom: '4px', borderBottom: '1px solid #ddd', fontSize: '12px' }}>
                                    {comunasDestino.find(comuna => comuna.id === cotizacion.fk_comuna_destino)?.nombre || '-'}
                                  </Typography>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '100%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>Detalles de la Carga</Typography>
                          <Typography variant="body1" style={{ paddingBottom: '4px', fontSize: '12px', whiteSpace: 'pre-line' }}>
                            {cotizacion.carga_detalles || '-'}
                          </Typography>
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                </Grid>

                {
                  cotizacion.fk_tipo_servicio.toString() === '2' ?
                  <>
                   <Grid item xs={12}>
                  <Paper className={classes.summaryPaper} style={{ marginBottom: '16px' }}>
                    <Typography variant="subtitle1" gutterBottom style={{ color: '#dc3545', fontSize: '14px', fontWeight: 'bold' }}>
                      Valores del Servicio (USD)
                    </Typography>
                    <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                      <div style={{ width: '50%' }}>
                        <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                          Como calcular el valor del servicio
                        </Typography>
                      </div>
                      <div style={{ width: '50%' }}>
                        <Typography variant="body1" style={{ fontSize: '12px' }}>
                          {comoCalcular}
                        </Typography>
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Producto
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_producto) > 0
                              ? Number(cotizacion.valor_producto)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Flete
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_flete) > 0
                              ? Number(cotizacion.valor_flete)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Seguro
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_seguro) > 0
                              ? Number(cotizacion.valor_seguro)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Gestión China
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_gestion_china) > 0
                              ? Number(cotizacion.valor_gestion_china)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Flete China
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_flete_china) > 0
                              ? Number(cotizacion.valor_flete_china)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Margen
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_margen) > 0
                              ? Number(cotizacion.valor_margen)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Aforo
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_aforo) > 0
                              ? Number(cotizacion.valor_aforo)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Neto
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}>
                            {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                            {Number(cotizacion.valor_neto) > 0
                              ? Number(cotizacion.valor_neto*1)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Iva
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>  
                          <Typography variant="body1" style={{ fontSize: '12px' }}> {Number(cotizacion.valor_iva) > 0
                              ? Number(cotizacion.valor_iva*1)
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0} </Typography>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                            Valor Total
                          </Typography>
                        </div>
                        <div style={{ width: '50%' }}>
                          <Typography variant="body1" style={{ fontSize: '12px' }}> {Number(cotizacion.valor_total) > 0
                              ? Number(cotizacion.valor_total*1) 
                                  .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                  .replace('US$', 'US $')
                              : 0} </Typography>
                        </div>
                      </div>
                    </div>
                  </Paper>
                </Grid>
                  </>
                  :
                  cotizacion.fk_tipo_servicio.toString() === '1' ?
                  <>
                    <Grid item xs={12}>
                        <Paper className={classes.summaryPaper} style={{ marginBottom: '16px' }}>
                            <Typography variant="subtitle1" gutterBottom style={{ color: '#dc3545', fontSize: '14px', fontWeight: 'bold' }}>
                              Valores del Servicio (USD)
                            </Typography>
                            <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                            <div style={{ width: '50%' }}>
                              <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                                Como calcular el valor del servicio
                              </Typography>
                            </div>
                            <div style={{ width: '50%' }}>
                              <Typography variant="body1" style={{ fontSize: '12px' }}>
                                {comoCalcular}
                              </Typography>
                            </div>
                            </div>
                            <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                                  Valor Neto
                                </Typography>
                              </div>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body1" style={{ fontSize: '12px' }}>
                                  {/* si el numero es valido lo formatearemos con punto para separador de miles y coma para separador decimal */}
                                  {Number(cotizacion.valor_neto) > 0
                                    ? Number(cotizacion.valor_neto*1)
                                        .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                        .replace('US$', 'US $')
                                    : 0}
                                </Typography>
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                                  Valor Iva
                                </Typography>
                              </div>
                              <div style={{ width: '50%' }}>  
                                <Typography variant="body1" style={{ fontSize: '12px' }}> {Number(cotizacion.valor_iva) > 0
                                    ? Number(cotizacion.valor_iva*1)
                                        .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                        .replace('US$', 'US $')
                                    : 0} </Typography>
                              </div>
                            </div>
                            <div style={{ display: 'flex', gap: '20px', paddingBottom: '4px', borderBottom: '1px solid #ddd' }}>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body2" style={{ color: '#000000', fontSize: '12px', fontWeight: 'bold' }}>
                                  Valor Total
                                </Typography>
                              </div>
                              <div style={{ width: '50%' }}>
                                <Typography variant="body1" style={{ fontSize: '12px' }}> {Number(cotizacion.valor_total) > 0
                                    ? Number(cotizacion.valor_total*1)
                                        .toLocaleString('es-CL', { style: 'currency', currency: 'USD' })
                                        .replace('US$', 'US $')
                                    : 0} </Typography>
                              </div>
                            </div>
                        </Paper>
                    </Grid>
                  </>
                  : null
                }

                <Grid 
                item xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '10px',
                }}
                >
                {cotizacion.fk_estado == 1 && (
                  <Button 
                    variant="contained" 
                    style={{ backgroundColor: '#dc3545', color: 'white' }} 
                    onClick={() => setShowConfirmAcceptCotizacionDialog(true)} // Use the passed handler
                    disabled={isAccepting} // Use the passed state
                  >
                    {isAccepting ? <CircularProgress size={24} color="inherit" /> : 'Aceptar'}
                  </Button>
                )}
                </Grid>
              </>
            </div>
            
            {/* botonera de acciones */}
            <div style={{
              boxSizing: 'border-box',
              paddingLeft: '20px',
              paddingRight: '20px',
              paddingBottom: '20px',
            }}>
              {/* mostraremos el boton de atras si el activeStep es mayor a 1 */}
              {activeStep > 1 && (
                <Button
                  variant="outlined"
                  className={classes.button}
                  title="Atrás"
                  style={{ marginRight: '10px!important' }}
                  onClick={() => handleStepChange(activeStep, 'back')}
                >
                  <i className="fas fa-arrow-left" />
                </Button>
              )}
              {/* mostraremos el boton de adelante si el activeStep es menor o igual a 3 */}
              {activeStep <= 3 && (
                <Button
                  variant="outlined"
                  className={classes.button}
                  title="Siguiente"
                  style={{ marginRight: '10px!important' }}
                  onClick={() => handleStepChange(activeStep, 'next')}
                >
                  <i className="fas fa-arrow-right" />
                </Button>
              )}
              {/* mostraremos el boton de compartir por whatsapp si el activeStep es igual a 3 */}
              {activeStep === 3 && (
                <>
                <Button
                  onClick={() => { handleShareWhatsapp() }}
                  variant="contained"
                  className={classes.button}
                  title="Compartir por WhatsApp"
                  style={{
                    backgroundColor: '#009730',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#007a25'
                    }
                  }}
                >
                  <WhatsAppIcon />
                </Button>
                <Button
                  variant="contained"
                  className={classes.button}
                  title="Descargar PDF"
                  onClick={() => { handleDownloadPdf() }}
                >
                  <i className="fas fa-download" />
                </Button>
                {/* vamos a mostrar un boton para compartir por contacto_correo */}
                <Button
                  variant="contained"
                  className={classes.button}
                  title="Compartir por correo"
                  onClick={() => { handleShareEmail() }}
                >
                  <i className="fas fa-envelope" />
                </Button>
                </>
              )}
              {/* mostraremos el boton de recargar página si el activeStep es igual a 3 */}
              <Button
                variant="contained"
                className={classes.button}
                title="Recargar página"
                style={{
                  backgroundColor: '#6c757d',
                  color: '#ffffff',
                  '&:hover': {
                    backgroundColor: '#5a6268'
                  }
                }}
                onClick={() => { handleLogoClick() }}
              >
                <i className="fas fa-sync-alt" />
              </Button>
            </div>

          </div>
        </div>
      </div>
      {/* floating button toogle left column */}
      <Button
        onClick={toggleLeftColumn}
        style={{
          position: 'fixed',
          top: '10px',
          left: '10px',
          zIndex: 1000,
          backgroundColor: isLeftColumnVisible ? '#ffffff' : '#dc3545 ',
          color: isLeftColumnVisible ? '#dc3545 ' : '#ffffff',
          '&:hover': {
            backgroundColor: '#c82333'
          }
        }}
      >
        <i className="fas fa-chevron-left" />
      </Button>
      <Dialog
        open={successDialogGlobal.open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleSuccessDialogGlobalClose();
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="success-dialog-title"
        aria-describedby="success-dialog-description"
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: theme.spacing(1)
          }
        }}
      >
        <DialogTitle id="success-dialog-title" style={{ paddingBottom: theme.spacing(1), paddingTop: theme.spacing(1) }}>
          <Box display="flex" alignItems="center">
            <CheckCircleOutlineIcon style={{ color: theme.palette.success.main, marginRight: theme.spacing(1), fontSize: '2rem' }} />
            <Typography variant="h6" style={{ fontWeight: 'bold', color: theme.palette.success.dark }}>
              {successDialogGlobal.title || 'Titulo del mensaje'}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers style={{ paddingTop: theme.spacing(2) }}>
          <DialogContentText id="success-dialog-description" style={{ color: theme.palette.text.primary }}>
            {successDialogGlobal.message || 'Mensaje del mensaje'}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: theme.spacing(1.5, 2) }}>
          <Button
            onClick={handleSuccessDialogGlobalClose}
            variant="contained"
            style={{
              backgroundColor: theme.palette.success.main,
              color: '#ffffff',
              borderRadius: '8px',
              padding: theme.spacing(1, 2.5),
              textTransform: 'none',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: theme.palette.success.dark,
              }
            }}
            autoFocus
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={errorDialogGlobal.open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleErrorDialogGlobalClose();
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: theme.spacing(1)
          }
        }}
      >
        <DialogTitle id="error-dialog-title" style={{ paddingBottom: theme.spacing(1), paddingTop: theme.spacing(1) }}>
          <Box display="flex" alignItems="center">
            <ErrorOutlineIcon style={{ color: theme.palette.error.main, marginRight: theme.spacing(1), fontSize: '2rem' }} />
            <Typography variant="h6" style={{ fontWeight: 'bold', color: theme.palette.error.dark }}>
              {errorDialogGlobal.title || 'Titulo del error'}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers style={{ paddingTop: theme.spacing(2) }}>
          <DialogContentText id="error-dialog-description" style={{ color: theme.palette.text.primary }}>
            {errorDialogGlobal.message || 'Mensaje del error'}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: theme.spacing(1.5, 2) }}>
          <Button
            onClick={handleErrorDialogGlobalClose}
            variant="contained"
            style={{
              backgroundColor: theme.palette.error.main,
              color: '#ffffff',
              borderRadius: '8px',
              padding: theme.spacing(1, 2.5),
              textTransform: 'none',
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: theme.palette.error.dark,
              }
            }}
            autoFocus
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showTipoDeServicioInfo}
        onClose={() => setShowTipoDeServicioInfo(false)}
        aria-labelledby="contenedor-info-title"
      >
        <DialogTitle id="contenedor-info-title">
          Tipos de Servicio
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* vamos a recorrer el array de servicios y mostrar el tipo de servicio */}
            {servicios.map((servicio, index) => (
              <Typography key={servicio.id} variant="body1" style={{ marginBottom: '16px' }}>
              <strong>{servicio.nombre}:</strong> <div dangerouslySetInnerHTML={{ __html: servicio.description }} />  
            </Typography>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowTipoDeServicioInfo(false)} style={{ backgroundColor: '#dc3545', color: '#ffffff', '&:hover': { backgroundColor: '#007a25' } }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showTipoDeCargaInfo}
        onClose={() => setShowTipoDeCargaInfo(false)}
        aria-labelledby="contenedor-info-title"
      >
        <DialogTitle id="contenedor-info-title">
          Tipos de Carga
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {tiposCargas && tiposCargas.length > 0 && tiposCargas.map((tipo) => (
              <Typography key={tipo.id} variant="body1" style={{ marginBottom: '16px' }}>
                <strong>{tipo.nombre}:</strong> <div dangerouslySetInnerHTML={{ __html: tipo.descripcion }} />  
              </Typography>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowTipoDeCargaInfo(false)} style={{ backgroundColor: '#dc3545', color: '#ffffff', '&:hover': { backgroundColor: '#007a25' } }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* --- Carga Peligrosa Dialog --- */}
      <Dialog
        open={showCargaPeligrosaDialog}
        onClose={() => setShowCargaPeligrosaDialog(false)}
        PaperProps={{
          style: {
            borderRadius: '8px',
          }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'red !important', // Color naranja para el título
          borderBottom: '1px solid #ffe0b2'
        }}>
          <WarningIcon color="warning" />
          Advertencia: Carga Peligrosa
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <DialogContentText>
            <Typography variant="body1" sx={{ mb: 2, color: '#ed6c02' }}>
              <strong>¡Importante!</strong>
            </Typography>
            <Typography variant="body2" sx={{ color: '#424242' }}>
              Ha seleccionado que su carga es peligrosa. Por favor, tenga en cuenta que:
            </Typography>
            <Box component="ul" sx={{ mt: 1, pl: 2 }}>
              <Typography component="li" variant="body2" sx={{ color: '#424242', mb: 1 }}>
                Deberá proporcionar toda la documentación requerida para el transporte de mercancías peligrosas.
              </Typography>
              <Typography component="li" variant="body2" sx={{ color: '#424242', mb: 1 }}>
                Es necesario cumplir con todas las regulaciones internacionales de transporte de carga peligrosa.
              </Typography>
              <Typography component="li" variant="body2" sx={{ color: '#424242' }}>
                Nuestro equipo se pondrá en contacto con usted para coordinar los detalles específicos.
              </Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #ffe0b2' }}>
          <Button
            onClick={() => setShowCargaPeligrosaDialog(false)}
            variant="contained"
            color="warning"
            sx={{
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#ed6c02'
              }
            }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showContenedorInfo}
        onClose={() => setShowContenedorInfo(false)}
        aria-labelledby="contenedor-info-title"
      >
        <DialogTitle id="contenedor-info-title">
          Tipos de Contenedores
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {
              tiposContenedores && tiposContenedores.length > 0 && tiposContenedores.map((contenedor) => (
                <Typography key={contenedor.id} variant="body1" style={{ marginBottom: '16px' }}>
                  <strong>{contenedor.nombre}:</strong> <div dangerouslySetInnerHTML={{ __html: contenedor.descripcion }} />  
                </Typography>
              ))
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowContenedorInfo(false)} style={{ backgroundColor: '#dc3545', color: '#ffffff', '&:hover': { backgroundColor: '#007a25' } }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showIncotermInfo}
        onClose={() => setShowIncotermInfo(false)}
        aria-labelledby="contenedor-info-title"
      >
        <DialogTitle id="contenedor-info-title">
          Incoterms
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {tiposIncoterms && tiposIncoterms.length > 0 && tiposIncoterms.map((incoterm) => (
              <Typography key={incoterm.id} variant="body1" style={{ marginBottom: '16px' }}>
                <strong>{incoterm.nombre}:</strong> <div dangerouslySetInnerHTML={{ __html: incoterm.descripcion }} />  
              </Typography>
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowIncotermInfo(false)} style={{ backgroundColor: '#dc3545', color: '#ffffff', '&:hover': { backgroundColor: '#007a25' } }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* --- Dialog para confirmar la aceptacion de la cotizacion --- */}
      <Dialog
        open={showConfirmAcceptCotizacionDialog}
        onClose={() => setShowConfirmAcceptCotizacionDialog(false)}
        aria-labelledby="confirm-accept-cotizacion-title"
      >
        <DialogTitle id="confirm-accept-cotizacion-title">
          Aceptar Cotización
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Al aceptar la cotizacion nuestro equipo se pondra en contacto con usted para coordinar los detalles de la recepcion de la carga en nuestras bodegas.
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', gap: '10px' }}>
          <Button 
            onClick={() => setShowConfirmAcceptCotizacionDialog(false)} 
            style={{ 
              backgroundColor: '#6c757d',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#5a6268'
              }
            }}
          >  
            Cancelar
          </Button>
          <Button 
            onClick={() => {
              setShowConfirmAcceptCotizacionDialog(false);
              handleAcceptCotizacion();
            }} 
            style={{ 
              backgroundColor: '#dc3545',
              color: '#ffffff',
              '&:hover': {
                backgroundColor: '#c82333'
              }
            }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CotizadorForm;